export const testimonials = [
  {
    initials: 'MG',
    name: 'Mariana G.',
    location: 'Rosario',
    role: 'Empleada administrativa · 2 hijos',
    text: 'Por fin algo pensado para Argentina. Empecé vendiendo organizadores con el Método Cero Stock y en el primer mes tuve 102 ventas. Ahora sé exactamente cuánto gano antes de publicar.',
  },
  {
    initials: 'GP',
    name: 'Gonzalo P.',
    location: 'Buenos Aires',
    role: 'Estudiante universitario',
    text: 'El tomo de publicaciones me cambió todo. Apliqué la fórmula del título, cambié las fotos y en 4 días tuve mis primeras ventas. El algoritmo me empezó a mostrar y no paré más.',
  },
  {
    initials: 'DF',
    name: 'Daniela F.',
    location: 'Córdoba',
    role: 'Mamá en casa, busca ingreso extra',
    text: 'El directorio de proveedores fue lo que me hizo arrancar de verdad. Llamé el mismo día y a la semana tenía mis primeras publicaciones activas con buen margen.',
  },
]

export const moreTestimonials = [
  {
    initials: 'MG',
    name: 'Mariana G.',
    age: 34,
    location: 'Rosario',
    role: 'Empleada administrativa · 2 hijos',
    text: 'Por fin encontré algo pensado para Argentina de verdad. Empecé vendiendo organizadores de hogar con el Método Cero Stock y en el primer mes tuve 102 ventas. Antes no sabía ni qué significaba "comisión de ML". Ahora sé exactamente cuánto gano por cada venta antes de publicarla.',
  },
  {
    initials: 'GP',
    name: 'Gonzalo P.',
    age: 22,
    location: 'Buenos Aires',
    role: 'Estudiante universitario',
    text: 'El tomo de publicaciones me cambió todo. Tenía 3 publicaciones que no vendían nada. Apliqué la fórmula del título, cambié las fotos con el setup del bono y en 4 días tuve mis primeras ventas. El algoritmo me empezó a mostrar y no paré más.',
  },
  {
    initials: 'DF',
    name: 'Daniela F.',
    age: 31,
    location: 'Córdoba',
    role: 'Mamá en casa, busca ingreso extra',
    text: 'El directorio de proveedores fue lo que me hizo arrancar de verdad. No tenía idea de dónde conseguir productos a precio mayorista. Con esos contactos llamé el mismo día y a la semana ya tenía mis primeras publicaciones activas con buen margen.',
  },
  {
    initials: 'AL',
    name: 'Adrián L.',
    age: 39,
    location: 'Tucumán',
    role: 'Trabajador independiente',
    text: 'El plan de 90 días es increíble. Soy muy desorganizado y siempre empiezo cosas y las dejo. Con ese plan supe exactamente qué hacer cada semana. Llegué al mes 3 con 28 publicaciones activas y el termómetro en verde. Nunca pensé que iba a llegar tan lejos.',
  },
  {
    initials: 'HV',
    name: 'Hernán V.',
    age: 28,
    location: 'Mendoza',
    role: 'Empleado en relación de dependencia',
    text: 'Lo que más me sirvió fue entender la psicología del comprador del Tomo 4. Mis publicaciones parecían profesionales pero no convertían. Apliqué los 6 principios y el anclaje de precio y mi tasa de conversión se fue al triple. Mismo producto, mismas fotos, diferente presentación.',
  },
]

export const tomos = [
  {
    id: 'T1',
    name: 'La Mentalidad y el Radar del Vendedor',
    months: 'Fundamentos',
    content:
      'La base que todo vendedor nuevo necesita antes de publicar su primer producto. Cómo detectar demanda real, encontrar micro-nichos rentables y empezar a pensar como un operador digital, no como un consumidor.',
    icon: '📘',
  },
  {
    id: 'T2',
    name: 'Publicaciones de Alto Impacto',
    months: 'La ciencia del click',
    content:
      'Cómo construir publicaciones que el algoritmo de ML ame y el comprador no pueda ignorar. Títulos, fotos profesionales con el celular, descripciones que cierran ventas y psicología del precio.',
    icon: '📗',
  },
  {
    id: 'T3',
    name: 'Modelo Cero Stock y Red de Proveedores',
    months: 'El método V.P.A.',
    content:
      'El sistema para vender sin invertir en mercadería propia. El Método V.P.A. (Validar, Publicar, Adquirir) paso a paso, cómo encontrar proveedores locales confiables y gestionar tiempos sin perder reputación.',
    icon: '📙',
  },
  {
    id: 'T4',
    name: 'Reputación, Atención y Psicología de Ventas',
    months: 'Blindaje de cuenta',
    content:
      'Cómo funciona el termómetro de reputación, los 6 principios de psicología de ventas aplicados a ML, scripts de atención al cliente y cómo gestionar reclamos sin perder dinero ni reputación.',
    icon: '📕',
  },
  {
    id: 'T5',
    name: 'Escalar: De Vendedor Casual a Operador Profesional',
    months: 'Plan de 90 días',
    content:
      'Cómo convertir lo aprendido en un ingreso real y creciente. Análisis de métricas, construcción de catálogo de 30+ productos, automatización con herramientas gratuitas y cuándo formalizarte legalmente.',
    icon: '📓',
  },
]

export const bonuses = [
  {
    id: '01',
    icon: '📊',
    name: 'Plantilla Maestra de Control Operativo',
    desc: 'Planilla de Google Sheets para gestionar hasta 50 publicaciones: proveedores, precios, márgenes y métricas. Lista para copiar a tu Drive.',
    value: '$8.000',
  },
  {
    id: '02',
    icon: '🧮',
    name: 'Calculadora de Margen Real para ML Argentina',
    desc: 'Calculá el margen neto considerando comisiones de ML, envío, costo del proveedor e impuestos. Nunca más publiques sin saber cuánto ganás.',
    value: '$6.500',
  },
  {
    id: '03',
    icon: '💬',
    name: 'Pack de Scripts de Atención al Cliente',
    desc: 'Las 10 respuestas más frecuentes en ML redactadas profesionalmente. Listas para copiar y pegar desde el celular. Incluye script de calificación positiva.',
    value: '$5.500',
  },
  {
    id: '04',
    icon: '📸',
    name: 'Guía Rápida de Fotos Profesionales con el Celular',
    desc: 'Cómo fotografiar cualquier producto con fondo blanco y luz natural. Setup con materiales de menos de $2.000 ARS.',
    value: '$4.500',
  },
]

export const faqs = [
  {
    q: '¿Necesito tener plata para empezar a vender?',
    a: 'No. El Método Cero Stock está diseñado exactamente para eso: publicás primero, y comprás el producto al proveedor recién cuando tenés la venta confirmada con el dinero del comprador en tu cuenta. Tu inversión es la guía, no el stock.',
  },
  {
    q: '¿Cómo recibo el material?',
    a: '100% digital. Después de confirmar el pago por Mercado Pago recibís un email con el enlace de descarga en menos de 5 minutos. Accedés desde tu celular, computadora o tablet. Sin esperas, sin envíos físicos.',
  },
  {
    q: '¿Sirve si nunca vendí nada online?',
    a: 'Sí. La guía está construida desde cero absoluto. El Tomo 1 empieza desde la creación de la cuenta y avanza de forma progresiva. No necesitás experiencia previa ni conocimientos técnicos.',
  },
  {
    q: '¿Qué lo diferencia de los videos de YouTube?',
    a: 'Los videos de YouTube son fragmentados, no están ordenados para el mercado argentino y mezclan información de todos los niveles sin un sistema progresivo. Esta guía es un sistema completo, en español argentino, con plantillas y calculadoras listas para usar desde el día 1.',
  },
  {
    q: '¿La garantía es real?',
    a: 'Absolutamente. Si en 7 días desde la compra sentís que el material no era lo que esperabas, escribís a compradigitalyaa@gmail.com y te devolvemos el 100% sin preguntas ni formularios. Menos del 1% de los compradores la pide.',
  },
  {
    q: '¿Sirve si vivo en el interior del país?',
    a: 'Sí. El Método Cero Stock funciona en cualquier provincia de Argentina. La guía incluye cómo encontrar proveedores locales en tu ciudad además del directorio nacional disponible en la versión completa.',
  },
  {
    q: '¿Los bonos están incluidos en ambas versiones?',
    a: 'Sí. Los 4 bonos están incluidos en las dos versiones. La diferencia entre la versión básica y la versión completa es el Directorio Exclusivo de 25 Proveedores Verificados con contacto directo por WhatsApp.',
  },
  {
    q: '¿Puedo editar las plantillas y calculadoras?',
    a: 'Sí. Las plantillas de Google Sheets son completamente editables. Las copiás a tu propio Drive y las personalizás como necesitás.',
  },
  {
    q: '¿Hay que pagar alguna mensualidad o suscripción?',
    a: 'No. Es un pago único. Comprás una vez y el material es tuyo para siempre. Sin suscripciones, sin pagos recurrentes, sin sorpresas.',
  },
  {
    q: '¿Qué medios de pago aceptan?',
    a: 'Mercado Pago, tarjeta de crédito y débito, transferencia bancaria. Todos los medios disponibles en Argentina.',
  },
]

export const purchaseNotifications = [
  { name: 'Mariana G.', city: 'Rosario', plan: 'Guía Completa Mercado Libre' },
  { name: 'Gonzalo P.', city: 'Buenos Aires', plan: 'Guía + Directorio' },
  { name: 'Daniela F.', city: 'Córdoba', plan: 'Guía Completa Mercado Libre' },
  { name: 'Adrián L.', city: 'Tucumán', plan: 'Guía + Directorio' },
  { name: 'Hernán V.', city: 'Mendoza', plan: 'Guía Completa Mercado Libre' },
  { name: 'Lucía S.', city: 'Salta', plan: 'Guía + Directorio' },
  { name: 'Nicolás P.', city: 'Tucumán', plan: 'Guía Completa Mercado Libre' },
  { name: 'Romina V.', city: 'Neuquén', plan: 'Guía + Directorio' },
  {
    name: 'Sebastián L.',
    city: 'Bahía Blanca',
    plan: 'Guía Completa Mercado Libre',
  },
  { name: 'Martín C.', city: 'La Plata', plan: 'Guía + Directorio' },
]
